import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import CreatePreviewModal from "@/components/preview/create-preview-modal"
import { Badge } from "@/components/ui/badge"
import { Model } from "@/lib/types";
import { useTranslation } from "react-i18next";

interface ModelCardProps {
  model: Model;
}

export default function ModelCard({ model }: ModelCardProps) {
  const { t, i18n } = useTranslation("common");
  const isRTL = i18n.language === "ar"; // Determine if the current language is RTL

  return (
    <Card
      className={`overflow-hidden flex flex-col h-full pt-0 gap-4 ${
        isRTL ? "rtl" : "ltr"
      }`}
    >
      <div className="relative aspect-video w-full">
        <img
          src={model.thumbnail}
          alt={model.name}
          className="object-cover w-full h-full"
        />
        {!model.enabled && (
          <div className={`absolute top-2 ${isRTL ? "left-2" : "right-2"}`}>
            <Badge variant="destructive">
              {t("common:modelCard.comingSoon")}
            </Badge>
          </div>
        )}
      </div>
      <CardHeader className={`py-0 ${isRTL ? "text-right" : "text-left"}`}>
        <CardTitle className="line-clamp-1 text-xl">{model.name}</CardTitle>
      </CardHeader>
      <CardContent
        className={`flex-grow ${isRTL ? "text-right" : "text-left"}`}
      >
        <p className="text-muted-foreground line-clamp-3 text-sm">
          {model.description}
        </p>
      </CardContent>
      <CardFooter className={isRTL ? "text-right" : "text-left"}>
        <CreatePreviewModal
          trigger={
            <Button
              className="w-full cursor-pointer font-semibold"
              disabled={!model.enabled}
            >
              {t("common:modelCard.useModel")}
            </Button>
          }
          title={
            <div
              dir={isRTL ? "rtl" : "ltr"}
              className={isRTL ? "text-right" : "text-left"}
            >
              {t("common:modelCard.uploadLabel", { modelName: model.name })}
            </div>
          }
          description={
            <div
              className={`flex flex-col space-y-2 text-sm ${
                isRTL ? "text-right" : "text-left"
              }`}
            >
              <div>
                {t("common:modelCard.uploadDescription")}
                <Badge
                  variant="outline"
                  className={`mx-3 ${isRTL ? "ml-auto" : "mr-auto"}`}
                >
                  {t("common:modelCard.ratio", {
                    ratio: model.settings?.ratio,
                  })}
                </Badge>
              </div>
            </div>
          }
          upload_text={t("common:modelCard.uploadAndCreate")}
          modelUuid={model.uuid}
          targetRatio={model.settings.ratio}
        />
      </CardFooter>
    </Card>
  )
}

